import { jwtDecode } from "jwt-decode";
import { hostUrl, jsonHeaders, message, request } from "./core";

export const login = (payload) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/auth/login"),
    headers: jsonHeaders({ bearer: false }),
    data: JSON.stringify(payload),
  };
  return request(config)
    .then((response) => {
      localStorage.setItem("token", response.data.token);
      window.location.reload();
    })
    .catch((error) => {
      message.error(error?.response?.data?.message || "Server is Down");
    });
};

export const googleLogin = (payload) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/auth/google/login"),
    headers: jsonHeaders({ bearer: false }),
    data: JSON.stringify(payload),
  };
  return request(config)
    .then((response) => {
      localStorage.setItem("token", response.data.token);
      window.location.reload();
    })
    .catch((error) => {
      message.error(error?.response?.data?.message || "Server is Down");
    });
};

export const verify = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  const decode = jwtDecode(token);
  if (Date.now() > decode?.exp * 1000) return false;
  return true;
};
